import React, { useEffect } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import WhatsAppFloat from '../components/WhatsAppFloat';

const Team = () => {
    useEffect(() => {
        // Force hide spinner immediately
        const spinner = document.getElementById('spinner');
        if (spinner) {
            spinner.classList.remove('show');
            spinner.style.display = 'none';
            spinner.style.opacity = '0';
            spinner.style.visibility = 'hidden';
        }
        if (window.WOW) {
            new window.WOW().init();
        }
    }, []);

    // Note: The HTML file had the team section commented out. We can include the commented section or render it.
    // I'll render the structure properly but leave it similar to as it was, or rather just the title and footer since it was commented out HTML.
    // Actually, I'll export the structure as it was commented out, or just export the un-commented parts which is just the header.
    // Let's include the commented part as JSX comments or properly just the valid content.
    return (
        <>
            <WhatsAppFloat />
            <Navbar />

            {/* Page Header Start */}
            <div className="container-fluid page-header mb-5 wow fadeIn" data-wow-delay="0.1s">
                <div className="container">
                    <h1 className="display-3 mb-4 animated slideInDown">Team Member</h1>
                    <nav aria-label="breadcrumb animated slideInDown">
                        <ol className="breadcrumb mb-0">
                            <li className="breadcrumb-item"><a href="/">Home</a></li>
                            <li className="breadcrumb-item active" aria-current="page">Team Member</li>
                        </ol>
                    </nav>
                </div>
            </div>
            {/* Page Header End */}

            {/* Team section was commented out in original HTML. Leaving placeholder. */}
            <div className="container-xxl py-5">
                <div className="container text-center">
                    <p>Team section coming soon.</p>
                </div>
            </div>

            <Footer />
        </>
    );
};

export default Team;
